import styled from 'styled-components'

const SampleProofImg = styled.img`
  width: calc(100vw * (190 / 375));
  height: calc(100vw * (190 / 375));
  object-fit: cover;
`

export default SampleProofImg
